import { getPartnerConfigBySlug } from "@/lib/partners/registry"

const PARTNER_LP_PATH = /^\/parcerias\/([a-z0-9][a-z0-9-]*[a-z0-9])\/?$/i

/** Campanhas em path curto (fora de `/parcerias/{slug}`). */
const CAMPAIGN_PARTNER_PATHS: Record<string, string> = {
  "/feijoada-solidaria": "feijoada-solidaria",
  "/pcycle": "pcycle",
}

/** Path público da LP. Campanhas curtas não vivem em `/parcerias/{slug}`. */
export function getPartnerPublicPath(slug: string): string {
  const normalized = slug.trim().toLowerCase()
  for (const [path, campaignSlug] of Object.entries(CAMPAIGN_PARTNER_PATHS)) {
    if (campaignSlug === normalized) return path
  }
  return `/parcerias/${normalized}`
}

function normalizePathname(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1)
  }
  return pathname
}

function partnerExposesLandingPath(slug: string): boolean {
  const config = getPartnerConfigBySlug(slug)
  if (!config) return false
  return config.metadata?.publicLanding !== false
}

/** True quando a rota é `/parcerias/{slug}` com slug no registry (LPs co-branded longas). */
export function isPartnerLandingPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false
  const match = normalizePathname(pathname).match(PARTNER_LP_PATH)
  if (!match?.[1]) return false
  return partnerExposesLandingPath(match[1])
}

/** Slug do parceiro quando a rota é `/parcerias/{slug}` ou campanha mapeada (ex.: `/pcycle`, `/feijoada-solidaria`). */
export function getPartnerSlugFromPathname(pathname: string | null | undefined): string | null {
  if (!pathname) return null
  const normalized = normalizePathname(pathname)

  const campaignSlug = CAMPAIGN_PARTNER_PATHS[normalized]
  if (campaignSlug) {
    const config = getPartnerConfigBySlug(campaignSlug)
    return config?.slug ?? null
  }

  const match = normalized.match(PARTNER_LP_PATH)
  if (!match?.[1]) return null
  if (!partnerExposesLandingPath(match[1])) return null
  return match[1].toLowerCase()
}
